import {
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import {
  BibliographicResource,
  BibliographicResourceType,
} from '®shared/bibliographic-resource';
import { Importance } from '®shared/tenant';

@Component({
  selector: 'rl-fielded-resource',
  templateUrl: './fielded-resource.component.html',
})
export class FieldedResourceComponent {
  BibliographicResourceType = BibliographicResourceType;

  @Input() resource: BibliographicResource;
  @Input() itemImportance?: Importance;
  @Input() listId?: string;
  @Input() ariaControlsId?: string;
  @Input() isClickable?: boolean;
  @Input() isExpanded?: boolean;
  @Output() resourceClicked = new EventEmitter<any>();

  @ContentChild('itemImportanceTemplate')
  itemImportanceTemplate: TemplateRef<any>;

  get isDisclosure(): boolean {
    return this.ariaControlsId ? true : false;
  }
}
